import { IDocuments, IPaginationResponse } from "../types";
import {
  IAdditionalMailing,
  IAdditionalMailingParams,
  IAdditionalMailingsParams,
  IAdditionalMailingDocumentsParams,
} from "./types";
import { rootApi } from "../rootApi";

export const additionalMailingApis = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    additionalMailings: builder.query<
      IPaginationResponse<IAdditionalMailing>,
      IAdditionalMailingsParams
    >({
      query: ({ limit, ordering, offset, tab, issuerId }) => ({
        url: `additional-mailings/`,
        params: {
          limit,
          ordering,
          offset,
          tab,
          issuer_id: issuerId || undefined,
        },
      }),
      providesTags: ["additionalMailings"],
    }),
    additionalMailing: builder.query<
      IAdditionalMailing,
      IAdditionalMailingParams
    >({
      query: ({ id }) => ({
        url: `additional-mailings/${id}/`,
      }),
      providesTags: (_result, _, arg) => [
        { type: "additionalMailings", id: arg.id },
      ],
    }),
    additionalMailingDocuments: builder.query<
      IDocuments[],
      IAdditionalMailingDocumentsParams
    >({
      query: ({ id }) => ({
        url: `additional-mailings/${id}/documents/`,
      }),
      providesTags: (_result, _, arg) => [
        { type: "additionalMailingDocuments", id: arg.id },
      ],
    }),
  }),
});

export const {
  useAdditionalMailingQuery,
  useAdditionalMailingsQuery,
  useAdditionalMailingDocumentsQuery,
} = additionalMailingApis;
